import PricingPlanCard from './pricing-plan-card';

export default PricingPlanCard;
